
<div id="my-carousel" class="owl-carousel" data-dots="false" data-nav="false" data-items="6" data-items-laptop="4" data-items-tab="2" data-items-mobile="1" data-items-mobile-sm="1" data-autoplay="true" data-loop="true" data-margin="30">
    <div *ngFor ="let item of Images" class="item">
        <div class="iq-client-img">
            <img src="{{ item.image }}" class="img-fluid" alt="client-img" />
        </div>
    </div>
</div>
                